import { getParamsOfUrl, getUrl } from '../../mixins/search';
import { getOrderParams } from '../../mixins/property-list';
import { addQueryArgs } from '@wordpress/url';
import { displayPropertyMapBound } from '../../../mixins/map';
import { getQuery } from '../advanced-search/advanced-search';

const headerMapNode = document.querySelector( '#realpress-header-map' );
let mapAreaNode, sortNode, containerNode, searchNode;
//Loadmore
const loadMoreWrapperNode = headerMapNode.querySelector( '.realpresss-load-more' );
let loadmoreBtnNode, loadingNode;

//infinite scroll
const infiniteScrollNode = headerMapNode.querySelector( '.realpresss-infinite-scroll' );
let infiniteLoadingNode;

let map;

const restNamespace = REALPRESS_GLOBAL_OBJECT.rest_namespace || '';
const paginationType = REALPRESS_GLOBAL_OBJECT.pagination_type || '';

const defaultQuery = { orderby: 'date', order: 'desc', has_coordinates: true, template: 'header_map' };
let query = {};
let isFetching = false;
let nextPage = null;
let reseting = false;

const realpressHeaderMap = () => {
	if ( ! headerMapNode ) {
		return;
	}

	mapAreaNode = headerMapNode.querySelector( '.realpress-hm-map-area' );
	sortNode = headerMapNode.querySelector( '.realpress-sort-by' );
	containerNode = headerMapNode.querySelector( '.realpress-property-container' );
	searchNode = headerMapNode.querySelector( '.realpress-advanced-search' );

	const queryParams = getParamsOfUrl();
	if ( Object.keys( queryParams ).length ) {
		query = { ...query, ...queryParams };
	}

	//Loadmore
	if ( loadMoreWrapperNode ) {
		loadmoreBtnNode = loadMoreWrapperNode.querySelector( '.realpress-load-more-btn' );
		loadingNode = loadMoreWrapperNode.querySelector( '.realpress-loading-display' );
	}

	//Infinite Scroll
	if ( infiniteScrollNode ) {
		infiniteLoadingNode = infiniteScrollNode.querySelector( '.realpress-loading-display' );
	}

	sort();
	if ( searchNode ) {
		reset();
		search();
	}
	getProperties( query );
	pagination();
};

const getProperties = ( queryParam = {}, isLoadmore = false ) => {
	if ( isLoadmore === false ) {
		containerNode.style.opacity = 0.4;
	}

	const param = { ...defaultQuery, ...queryParam };
	wp.apiFetch( {
		path: addQueryArgs( '/' + restNamespace + '/properties', param ),
		method: 'GET',
	} ).then( ( res ) => {
		if ( res.data.content !== undefined ) {
			if ( isLoadmore ) {
				containerNode.insertAdjacentHTML( 'beforeend', res.data.content );
			} else {
				containerNode.innerHTML = res.data.content;
			}

			map = displayPropertyMapBound( map, res.data.property, 'realpress-hm-map-area' );
		} else {
			map = displayPropertyMapBound( map, [], 'realpress-hm-map-area' );
			if ( loadMoreWrapperNode ) {
				loadMoreWrapperNode.style.display = 'none';
			}
			if ( res.msg && isLoadmore === false ) {
				containerNode.innerHTML = `<p>${ res.msg }</p>`;
			}
		}

		renderPagination( res );
	} ).catch( ( err ) => {
		console.log( err );
	} ).finally( () => {
		if ( isLoadmore === false ) {
			const urlPush = getUrl( query );
			window.history.pushState( '', '', urlPush );
		}
		containerNode.style.opacity = 1;
	} );
};

const sort = () => {
	sortNode.addEventListener( 'change', function( event ) {
		if ( reseting ) {
			return;
		}

		const selected = event.target.value;
		const sortParams = getOrderParams( selected );
		query = { ...query, ...sortParams };
		//Loadmore and infinite scroll
		if ( paginationType !== 'standard' && Object.hasOwn( query, 'page' ) ) {
			delete query.page;
		}

		getProperties( query );
	} );
};

const reset = () => {
	const resetButtonNode = searchNode.querySelector( 'button.realpress-reset' );
	if ( resetButtonNode ) {
		resetButtonNode.addEventListener( 'click', function() {
			reseting = true;
			sortNode.tomselect.setValue( 'default' );
			query = {};
			getProperties( query );
			reseting = false;
		} );
	}
};

const search = () => {
	document.addEventListener( 'click', function( event ) {
		if ( event.target.classList.contains( 'realpress-search' ) || event.target.classList.contains( 'realpress-view-all' ) ) {
			query = getQuery( query );

			if ( Object.hasOwn( query, 'page' ) ) {
				delete query.page;
			}

			getProperties( query );
		}
	} );
};

const renderPagination = ( res ) => {
	if ( paginationType === 'standard' ) {
		if ( res.data.pagination !== undefined ) {
			headerMapNode.querySelector( '.realpress-pagination' ).innerHTML = res.data.pagination;
		} else {
			headerMapNode.querySelector( '.realpress-pagination' ).innerHTML = '';
		}

		if ( res.data.from_to !== undefined ) {
			headerMapNode.querySelector( '.realpress-from-to' ).innerHTML = res.data.from_to;
		} else {
			headerMapNode.querySelector( '.realpress-from-to' ).innerHTML = '';
		}
	}

	if ( paginationType === 'loadmore' ) {
		if ( res.data.pagination === undefined ) {
			nextPage = null;
			return;
		}

		loadmoreBtnNode.innerHTML = res.data.pagination;
		loadingNode.style.display = 'none';
		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}

	if ( paginationType === 'infinite_scroll' ) {
		infiniteLoadingNode.style.display = 'none';
		isFetching = false;
		if ( res.data.next_page ) {
			nextPage = res.data.next_page;
		} else {
			nextPage = null;
		}
	}
};

const pagination = () => {
	document.addEventListener( 'click', function( event ) {
		const target = event.target;
		const item = target.closest( 'a' );
		if ( paginationType === 'standard' ) {
			if ( ! item ) {
				return;
			}

			if ( ! item.getAttribute( 'data-page' ) ) {
				return;
			}

			const paginationNode = target.closest( '.realpress-pagination' );
			if ( ! paginationNode ) {
				return;
			}
			event.preventDefault();
			const page = item.getAttribute( 'data-page' );
			query = { ...query, page };
			getProperties( query );
			headerMapNode.scrollIntoView( { behavior: 'smooth' } );
		}

		if ( paginationType === 'loadmore' ) {
			if ( target.parentNode !== loadmoreBtnNode ) {
				return;
			}

			event.preventDefault();
			target.remove();
			loadingNode.style.display = 'block';
			query = { ...query, page: nextPage };
			getProperties( query, true );
		}
	} );

	if ( paginationType === 'infinite_scroll' ) {
		window.addEventListener( 'scroll', ( event ) => {
			getScrollData();
		} );
	}
};

const getScrollData = () => {
	const distance = infiniteScrollNode.getBoundingClientRect().top - window.innerHeight;

	if ( isFetching === false && distance < 0 && nextPage ) {
		isFetching = true;
		infiniteLoadingNode.style.display = 'block';
		query = { ...query, page: nextPage };
		getProperties( query, true );
	}
};

export default realpressHeaderMap;
